// Function to load the Zendesk snippet
function loadZendeskSnippet() {
    var zendeskScript = document.createElement('script');
    zendeskScript.id = 'ze-snippet';
    zendeskScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=ca2b1bf1-1167-4059-b0d2-35886e507270';
    
    // Once the script is loaded, configure the widget
    zendeskScript.onload = function() {
        configureZendeskWidget();
    };

    document.head.appendChild(zendeskScript);
}

// Function to configure the Zendesk widget
function configureZendeskWidget() {
    zE('webWidget:on', 'chat:departmentStatus', function(dept) {
        var settings = {
            webWidget: {
                contactOptions: { enabled: true },
                contactForm: { title: { '*': 'Eine Nachricht senden' } },
                chat: {},
                launcher: {}
            }
        };

        if (dept.name === 'Multiclient Team 1') {
            if (dept.status === 'online') {
                settings.webWidget.contactOptions = {
                    contactButton: { '*': 'Eine Nachricht senden' },
                    chatLabelOnline: { '*': 'Live-Chat' },
                    contactFormLabel: { '*': 'Eine Nachricht senden' }
                };
                settings.webWidget.chat = {
                    title: { '*': 'Chatten Sie mit uns' },
                    departments: { enabled: [''], select: 'Multiclient Team 1' },
                    menuOptions: { emailTranscript: false },
                    suppress: false
                };
                settings.webWidget.launcher = { chatLabel: { '*': 'Chat' } };
            } else {
                settings.webWidget.contactOptions.contactFormLabel = { '*': 'Eine Nachricht senden' };
                settings.webWidget.chat.suppress = true;
                settings.webWidget.launcher.label = { '*': 'Kontakt' };
            }
        }

        zE('webWidget', 'updateSettings', settings);
    });

    // Set Locale
    zE('webWidget', 'setLocale', 'de');
}

 window.zESettings = {
    webWidget: {
      offset: {
        horizontal: '-10px',
        vertical: '54px',
        mobile: {
          horizontal: '-10px',
          vertical: '35px'
        }
      }
    }
  };



// Load the Zendesk snippet
loadZendeskSnippet();